import * as React from "react";
function SvgIconFoldEnable(props) {
  return <svg width="1em" height="1em" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4.4 2.832a.4.4 0 01.65-.312l3.96 3.168a.4.4 0 010 .624L5.05 9.48a.4.4 0 01-.65-.312V2.832z" fill="#fff" opacity={0.7} /></svg>;
}
export default SvgIconFoldEnable;